/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import store from "../store";

export default {
    SET_CAPS (state, income) {
        const geosMatch = [],
            modelMatch = []
        state.capsInfo.geo = []
        state.capsInfo.model = []
        // if (income.response.data && Array.isArray(income.response.data.result)) {
            income.data.result.advertisers.map((val, index) => {
                val.advertiser_integrations.map((val, index) => {
                    if (geosMatch.indexOf(val.geo.name) === -1) {
                        geosMatch.push(val.geo.name)

                        state.capsInfo.geo.push({name: val.geo.name, id: val.geo.id})
                    }
                    if (modelMatch.indexOf(val.traffic_model.name) === -1) {
                        modelMatch.push(val.traffic_model.name)
                        state.capsInfo.model.push({name: val.traffic_model.name, id: val.traffic_model.id})
                    }
                })
            })

            state.capsList = income.data.result.advertisers

            income.data.result.advertisers.map(value => {
                value.advertiser_integrations.map(val => {
                    let sch = val.integration_setting.scheduling_caps

                    val.integration_setting.total_cap = 0
                    val.integration_setting.total_remainder = 0
                    // val.integration_setting[0].total_have = 0

                    val.integration_setting.virtual_cap_edit = false

                    for (let i = 0; i < sch.length; i++) {
                        // sch[i].have = ~~sch[i].remainder > 0 ? ~~sch[i].set - ~~sch[i].remainder : 0
                        val.integration_setting.total_cap += ~~sch[i].set
                        val.integration_setting.total_remainder += ~~sch[i].remainder
                        // val.integration_setting[0].total_have += ~~sch[i].have
                    }

                    val.integration_setting.total_remainder = val.integration_setting.total_cap - val.integration_setting.total_remainder
                })
            })

        // }


        // state.capsList = income.response.data.result
    },
    async UPDATE_CAPS () {

    },
    CHANGE_INTEGRATION_STATUS (state, income) {
        state.capsList[income.data.item.advid].advertiser_integrations[income.data.item.intArrId].is_active = !state.capsList[income.data.item.advid].advertiser_integrations[income.data.item.intArrId].is_active
    }
}
